export class ConfirmDialogData {
  constructor(public title: string, public message: string, public confirmText: string, public cancelText: string) {}
}
